module.exports = __webpack_public_path__ + "img/pics.63af2152.png";